import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import Register from "./components/Register";
import Signup from "./components/Signup";
import Login from "./components/Login";
import Applications from "./components/Applications";
import Jobs from "./components/Jobs";
import CreateJob from "./components/CreateJob";
import Interviews from "./components/Interviews";
import Notifications from "./components/Notifications";
import Profile from "./components/Profile";
import CreateStudentAccount from "./components/CreateStudentAccount";
import CreateCompanyAccount from "./components/CreateCompanyAccount";
import CompanyDashboard from "./components/CompanyDashboard";
import ViewApplication from "./components/ViewApplication";
import ViewJob from "./components/ViewJob";
import ApplyJob from "./components/ApplyJob";
import ViewJobApplications from "./components/ViewJobApplications";
import SetupInterview from "./components/SetupInterview";
import Loader from "./components/Loader";
import EditJob from "./components/EditJob";
import ResetPassword from "./components/ResetPassword";
import ResetPasswordMessage from "./components/ResetPasswordMessage";
import Landing from "./components/Landing";
import ProtectedRoute from "./components/ProtectedRoute";
import UnverifiedCompany from "./components/UnverifiedCompany";
import AdminDashboard from "./components/admin/AdminDashboard";
import Adminusers from "./components/admin/Adminusers";
import AdminOrg from "./components/admin/AdminOrg";
import AdminJobs from "./components/admin/AdminJobs";
import AdminOrgDetails from "./components/admin/AdminOrgDetails";
// import App from './App';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/unverified-company",
    element: <UnverifiedCompany />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/loader",
    element: <Loader />,
  },
  {
    path: "/create-student-account",
    element: <CreateStudentAccount />,
  },
  {
    path: "/create-company-account",
    element: <CreateCompanyAccount />,
  },
  {
    path: "/setup-interview",
    element: <SetupInterview />,
  },
  {
    path: "/loader",
    element: <Loader />,
  },
  {
    path: "/reset",
    element: <ResetPassword />,
  },
  {
    path: "/reset-message",
    element: <ResetPasswordMessage />,
  },
  {
    path: "edit-job/:id",
    element: <EditJob />,
  },
  {
    path: "/admindashboard",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/adminusers",
    element: (
      <ProtectedRoute>
        <Adminusers />
      </ProtectedRoute>
    ),
  },
  {
    path: "/adminjobs",
    element: (
      <ProtectedRoute>
        <AdminJobs />
      </ProtectedRoute>
    ),
  },
  {
    path: "/adminorg",
    element: (
      <ProtectedRoute>
        <AdminOrg />
      </ProtectedRoute>
    ),
  },
  {
    path: "/adminorg/details/:id",
    element: (
      <ProtectedRoute>
        <AdminOrgDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <CompanyDashboard />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/dashboard/jobs",
        element: <Jobs />,
        children: [
          {
            path: ":id",
            element: <ViewJob />,
          },
          {
            path: ":id/apply/:org_id",
            element: <ApplyJob />,
          },
          {
            path: ":org_id/:id",
            element: <ViewJobApplications />,
          },
        ],
      },
      {
        path: "/dashboard/create-job",
        element: <CreateJob />,
      },

      {
        path: "/dashboard/applications",
        element: <Applications />,
        children: [
          {
            path: ":applicationId", // Nested route for viewing an individual application
            element: <ViewApplication />,
          },
        ],
        // Other dashboard routes...
      },
      {
        path: "/dashboard/interviews",
        element: <Interviews />,
      },
      {
        path: "/dashboard/Notifications",
        element: <Notifications />,
      },
      {
        path: "/dashboard/profile",
        element: <Profile />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
